import { render, staticRenderFns } from "./FifthStep.vue?vue&type=template&id=7095b269&"
import script from "./FifthStep.vue?vue&type=script&lang=js&"
export * from "./FifthStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports